import React from 'react';
import contactsService from '../../services/contacts';

const ContactSearchBar = ({ searchQuery, onSearchChange, onSearchResults, onSearching, onShowCreateDrawer }) => {
  const handleSearchChange = (e) => {
    onSearchChange(e.target.value);
  };

  const handleSearchSubmit = async (e) => {
    e.preventDefault();
    if (searchQuery.trim().length >= 3) {
      onSearching(true);
      try {
        const results = await contactsService.searchContacts(searchQuery);
        // Asegurar que results sea un array
        onSearchResults(Array.isArray(results) ? results : []);
      } catch (error) {
        console.error('Error en búsqueda:', error);
        onSearchResults([]);
      } finally {
        onSearching(false);
      }
    }
  };

  return (
    <div className="contact-search-bar">
      <form onSubmit={handleSearchSubmit} className="search-form">
        <div className="form-group">
          <label htmlFor="searchQuery">Buscar contacto</label>
          <div className="search-input-container">
            <input
              type="text"
              id="searchQuery"
              value={searchQuery}
              onChange={handleSearchChange}
              placeholder="Buscar por nombre, apellido, CUIT/CUIL, email o telefono..."
              className="search-input"
            />
            <button type="submit" className="btn btn-primary search-btn" disabled={searchQuery.trim().length < 3}>
              Buscar
            </button>
            <button 
              type="button" 
              className="btn btn-secondary create-btn"
              onClick={onShowCreateDrawer}
            >
              Crear nuevo contacto
            </button>
          </div>
          <div className="search-help">
            <small>Ingrese al menos 3 caracteres para buscar</small>
          </div>
        </div>
      </form>
    </div>
  );
};

export default ContactSearchBar;
